import {isDEVMODE, domStorage, globalStorage, viewStorage} from '../_globals'

export default class Form {

  constructor(formSelector, matomoEvent = null) {

    this.DOM = {
      form: formSelector
    }

    this.matomoEvent = matomoEvent

    this.DOM.inputs = this.DOM.form.querySelectorAll('input, textarea')
    this.DOM.fields = this.DOM.form.querySelectorAll('input, select, textarea')
    this.DOM.resultText = this.DOM.form.querySelector('.Form__output p')
    this.DOM.submitBtn = this.DOM.form.querySelector('button[type=submit]')

    this.formURL = this.DOM.form.dataset.ajaxurl

    this.init()
  }

  init() {

    if (isDEVMODE) console.log('Init Form')

    this.addEvents()

  }

  addEvents() {

    const {form, inputs} = this.DOM

    this.onSubmit = this.onSubmit.bind(this)
    form.addEventListener('submit', this.onSubmit)

    this.onFocus = this.onFocus.bind(this)
    inputs.forEach(input => input.addEventListener('focusin', this.onFocus))
    inputs.forEach(input => input.addEventListener('focusout', this.onFocus))
  }

  onFocus(e) {
    const {type, currentTarget} = e
    if (type === 'focusin') currentTarget.parentNode.classList.add('--focused')
    else currentTarget.parentNode.classList.remove('--focused')

    if (type === 'focusout' && currentTarget.value !== '') currentTarget.parentNode.classList.add('--filled')
    else currentTarget.parentNode.classList.remove('--filled')
  }

  onSubmit(e) {
    e.preventDefault()

    const {body} = domStorage
    const {viewScroll} = viewStorage
    const {fields, submitBtn} = this.DOM

    body.classList.add('--loading')

    submitBtn.disabled = true

    /* Remove previous errors */
    this.resetErrors()

    /* Add values to formData */
    const formData = this.getData()

    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.execute('6Ldc7-InAAAAAPk6oK2RKrifQ1_wWa-gDkQ0KrZ6', {action: 'submit'}).then((token) => {

        formData.append('token', token);

        const xhr = new XMLHttpRequest()
        xhr.open('POST', this.formURL, true)
        xhr.onreadystatechange = () => {
          if (xhr.readyState === XMLHttpRequest.DONE) {

            switch (xhr.status) {
              case 200:
                this.onSuccess(xhr.responseText)
                window._paq = window._paq || [];
                window._mtm = window._mtm || [];
                window._paq.push(['FormAnalytics::trackFormConversion', '{formName}', this.DOM.form.id]);
                // submitWebCallBackSucceed
                if (this.matomoEvent) {
                  window._mtm.push({"event": this.matomoEvent});
                }
                console.log('Form submitted')
                break
              case 422:
                this.onInvalid(xhr.responseText)
                break
              case 500:
                this.onServerError(xhr.responseText)
                break
              case 504:
                this.onServerError('Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer plus tard.')
                break
              default:
                this.onServerError()
            }

            submitBtn.disabled = false

            fields.forEach(field => {
              field.disabled = false
            })

            body.classList.remove('--loading')
            // if (viewScroll) viewScroll.update()
          }
        }

        xhr.send(formData)
      });
    } else {
      const {resultText} = this.DOM
      resultText.innerHTML = 'A la suite d’un problème technique le formulaire ne peut être envoyé. Nous vous invitons à nous envoyer directement un email à relationclient@kerialis.fr ou à nous contacter par téléphone au 01 70 99 15 00 du lundi au jeudi de 9h à 18h et le vendredi jusqu\'à 17h.'
      resultText.classList.add('is--error')
    }
  }

  resetErrors() {
    const {form, resultText} = this.DOM

    resultText.innerHTML = ''
    resultText.classList.remove('--error')

    const errors = form.querySelectorAll('span.--error')
    errors.forEach((err) => {
      err.parentNode.classList.remove('--error')
      err.parentNode.removeChild(err)
    })
    const fieldsErrors = document.querySelectorAll('.--error')
    fieldsErrors.forEach((err) => {
      err.classList.remove('--error')
    })

  }

  getData() {
    const {fields} = this.DOM

    const formData = new FormData()
    fields.forEach(field => {
      field.disabled = true
      if (field.type === 'radio' || field.type === 'checkbox') {
        if (field.checked) formData.append(field.name, field.value)
      } else if (field.type === 'file') {
        if (field.multiple) {
          const ins = field.files.length;
          for (let i = 0; i < ins; i++) {
            formData.append(field.name[i], field.files[i]);
          }
        } else {
          formData.append(field.name, field.files[0]);
        }
      } else {
        formData.append(field.name, field.value)
      }
    })

    return formData
  }

  onSuccess(text) {
    const {form, resultText} = this.DOM

    resultText.innerHTML = text
    form.reset()
  }

  onInvalid(text) {
    const {form} = this.DOM
    const json = JSON.parse(text)

    for (const fieldName of Object.keys(json)) {
      const field = form.querySelector(`[name=${fieldName}]`)
      if (field) {
        const err = document.createElement('span')
        err.innerHTML = json[fieldName].join('. ')
        err.classList.add('--error')
        field.parentNode.appendChild(err)
        field.parentNode.classList.add('--error')
      } else {
        // Try to get the last field of name fieldName[]
        const fields = form.querySelectorAll(`[name='${fieldName}[]']`)
        const field = fields[fields.length - 1]
        fields.forEach(field => {
          field.parentNode.classList.add('--error')
        })
        if (field) {
          const err = document.createElement('span')
          const br = document.createElement('br')
          console.log('br', br)
          err.appendChild(br)
          console.log('err', err)
          err.innerHTML += json[fieldName].join('. ')
          err.classList.add('--error')
          field.parentNode.appendChild(err)
          field.parentNode.classList.add('--error')
        }
      }
    }
  }

  onServerError(text) {
    const {resultText} = this.DOM

    resultText.innerHTML = text
    resultText.classList.add('--error')
  }

  destroy() {
    const {form, inputs} = this.DOM

    form.removeEventListener('submit', this.onSubmit)
    inputs.forEach(input => input.removeEventListener('focusin', this.onFocus))
    inputs.forEach(input => input.removeEventListener('focusout', this.onFocus))
  }
}
